import React from 'react';
import Picture from '@Theme/natucare/components/Picture/Picture';
import * as styles from '../../TestimonialTile.module.scss';
// eslint-disable-next-line react/prop-types
const TestimonialPictureWrapper = _ref => {
  let {
    children,
    isCaption
  } = _ref;
  return isCaption ? /*#__PURE__*/React.createElement("figure", null, children) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
const TestimonialPicture = _ref2 => {
  let {
    picture,
    pictureHover,
    caption,
    productName
  } = _ref2;
  return /*#__PURE__*/React.createElement(TestimonialPictureWrapper, {
    isCaption: !!caption
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootPictureWrapper
  }, (picture === null || picture === void 0 ? void 0 : picture.xs) && /*#__PURE__*/React.createElement(Picture, {
    xs: {
      src: picture.xs
    },
    alt: picture.alt,
    pictureClassname: styles.rootPicture,
    imgClassname: styles.rootPictureImage
  }), (pictureHover === null || pictureHover === void 0 ? void 0 : pictureHover.xs) && /*#__PURE__*/React.createElement(Picture, {
    xs: {
      src: pictureHover.xs
    },
    alt: pictureHover.alt,
    pictureClassname: `${styles.rootPicture} ${styles.rootPictureHover}`,
    imgClassname: styles.rootPictureImage
  }), caption && /*#__PURE__*/React.createElement("figcaption", {
    className: styles.rootPictureCaption
  }, caption), productName && /*#__PURE__*/React.createElement("figcaption", {
    className: styles.rootProductName
  }, productName)));
};
export default TestimonialPicture;